import { Show, onCleanup } from "solid-js";
import { imageUrl } from "../data";
import { styles } from "../styles";
import type { CoordEntry } from "../types";
import { coordinateOwnershipStats } from "../features/catalog/ownership";
import { OwnershipSummary } from "./OwnershipSummary";
import { cx } from "../../styled-system/css";
import { fullImageMatchesColor } from "../search";
import type { ColorFilters } from "../types";
import { categoryDisplayName } from "../categories";

type Props = {
  entry: CoordEntry;
  showOwnership: boolean;
  onPreview: () => void;
  colorFilters?: ColorFilters;
};

export function LookbookCard(props: Props) {
  let timer: number | undefined;
  let startX = 0;
  let startY = 0;
  let longPressed = false;
  let moved = false;
  const cancelTimer = () => {
    if (timer !== undefined) window.clearTimeout(timer);
    timer = undefined;
  };
  onCleanup(cancelTimer);
  const ownership = () => coordinateOwnershipStats(props.entry.items);

  return (
    <article class={styles.lookbookCard} data-catalog-entry-key={props.entry.key}>
      <button
        class={cx(
          styles.lookbookButton,
          props.colorFilters && fullImageMatchesColor(props.entry, props.colorFilters) && styles.colorMatchedFrame,
        )}
        type="button"
        title={`${props.entry.name}の詳細を表示`}
        aria-label={`${props.entry.name}の詳細を表示`}
        onPointerDown={(event) => {
          if (event.button !== 0) return;
          startX = event.clientX;
          startY = event.clientY;
          moved = false;
          longPressed = false;
          cancelTimer();
          timer = window.setTimeout(() => {
            longPressed = true;
            props.onPreview();
            navigator.vibrate?.(30);
          }, 550);
        }}
        onPointerMove={(event) => {
          if (Math.hypot(event.clientX - startX, event.clientY - startY) > 10) {
            moved = true;
            cancelTimer();
          }
        }}
        onPointerUp={cancelTimer}
        onPointerCancel={cancelTimer}
        onPointerLeave={cancelTimer}
        onContextMenu={(event) => event.preventDefault()}
        onClick={(event) => {
          if (longPressed || moved) {
            event.preventDefault();
            longPressed = false;
            moved = false;
            return;
          }
          props.onPreview();
        }}
      >
        <img
          class={styles.lookbookImage}
          src={imageUrl(props.entry.url)}
          alt={`${props.entry.name} コーデ`}
          loading="lazy"
          decoding="async"
          draggable={false}
        />
        <span class={styles.lookbookCaption} data-lookbook-caption aria-hidden="true">
          <span class={styles.lookbookCaptionChapter}>{categoryDisplayName(props.entry.category)}</span>
          <span class={styles.lookbookCaptionName}>{props.entry.name}</span>
        </span>
      </button>
        <span class={styles.lookbookBadges}>
          <Show when={props.showOwnership && ownership().known}>
            <OwnershipSummary items={props.entry.items} />
          </Show>
        </span>
    </article>
  );
}
